import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useReveal } from "@/hooks/useReveal";
import { SAAS } from "@/data/services";

export default function Saas() {
    useReveal();
    return (
        <div data-testid="saas-page">
            {/* HERO */}
            <section className="container-x pt-16 pb-16 lg:pt-28 lg:pb-24 border-b border-brand-line">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 reveal">
                    <div className="lg:col-span-8">
                        <div className="flex items-center gap-4">
                            <div className="label-mono">Producto · Scalexa Group</div>
                            <span
                                className="label-mono !text-[10px] border border-brand-electric !text-brand-electric px-2.5 py-1"
                                data-testid="saas-badge"
                            >
                                {SAAS.badge}
                            </span>
                        </div>
                        <h1 className="mt-8 font-heading text-5xl lg:text-7xl leading-[0.98] tracking-tighter text-brand-navy">
                            {SAAS.name}
                        </h1>
                        <p className="mt-8 max-w-xl text-lg text-brand-gray leading-relaxed">
                            {SAAS.text}
                        </p>
                        <div className="mt-10 flex flex-wrap items-center gap-4">
                            <Link
                                to="/contact?interes=saas"
                                data-testid="saas-cta-newsletter"
                                className="btn-primary"
                            >
                                {SAAS.cta} <ArrowRight size={16} />
                            </Link>
                            <Link to="/services" data-testid="saas-cta-services" className="btn-ghost">
                                Descubre nuestros servicios
                            </Link>
                        </div>
                    </div>
                </div>
            </section>

            {/* NOTA */}
            <section className="container-x py-16 lg:py-24">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 reveal">
                    <div className="lg:col-span-3">
                        <div className="label-mono">Mientras tanto</div>
                    </div>
                    <div className="lg:col-span-8">
                        <p className="font-heading text-2xl lg:text-3xl leading-[1.3] text-brand-navy">
                            Nuestro SaaS es un producto independiente de las cinco
                            líneas de servicio. Si hoy necesitas crecer, mejorar
                            procesos o adoptar IA, podemos ayudarte desde la
                            consultoría y la ejecución.
                        </p>
                        <Link
                            to="/services"
                            data-testid="saas-link-services"
                            className="mt-8 inline-flex items-center gap-2 text-brand-electric hover:text-brand-navy transition-colors font-medium"
                        >
                            Explorar los cinco servicios <ArrowRight size={16} />
                        </Link>
                    </div>
                </div>
            </section>
        </div>
    );
}
